import { Link } from "react-router-dom";
import { Briefcase, ArrowRight } from "lucide-react";

/**
 * Public footer of the marketing landing page.
 * Pure presentation, no state — safe to extract.
 */
export default function LandingFooter() {
  return (
    <footer className="py-12 bg-slate-900 text-slate-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-violet-600 to-indigo-600 flex items-center justify-center">
                <Briefcase className="w-5 h-5 text-white" />
              </div>
              <span className="font-display font-bold text-xl text-white">Mon DCE Express</span>
            </div>
            <p className="text-sm text-slate-500 mb-4">Veille marchés publics et analyse DCE par IA.</p>
            <a
              href="https://www.linkedin.com/company/43274769"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors"
              data-testid="landing-linkedin-link"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
              </svg>
              <span>Suivez-nous sur LinkedIn</span>
            </a>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-4">Pages piliers</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/veille-marches-publics" className="hover:text-white transition-colors">Veille marchés publics</Link></li>
              <li><Link to="/trouver-appels-offres" className="hover:text-white transition-colors">Trouver appels d&apos;offres</Link></li>
              <li><Link to="/analyse-dce" className="hover:text-white transition-colors">Analyse DCE</Link></li>
              <li><Link to="/plateforme-appels-offres" className="hover:text-white transition-colors">Plateforme appels d&apos;offres</Link></li>
              <li><Link to="/repondre-marches-publics" className="hover:text-white transition-colors">Répondre aux marchés publics</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-4">En savoir plus</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/blog" className="hover:text-white transition-colors">Blog</Link></li>
              <li><Link to="/guide-appels-offres" className="hover:text-white transition-colors">Guide complet</Link></li>
              <li><Link to="/analyse-dce" className="hover:text-white transition-colors">Synthèse IA</Link></li>
              <li><Link to="/analyse-gratuite" className="hover:text-white transition-colors">Analyse gratuite</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-4">Légal</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/legal" className="hover:text-white transition-colors">Mentions légales</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            </ul>
            <h4 className="font-semibold text-white mb-4 mt-6">Partenaires</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  href="https://assistance-appel-offre.fr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors inline-flex items-center gap-1"
                >
                  Assistance Appel d&apos;Offre
                  <ArrowRight className="w-3 h-3" />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-sm text-slate-500">
            Sources: BOAMP • DECP • TED Europa • SNCF • ADP • Dematis
          </div>
          <div className="text-sm">
            © 2026 Mon DCE Express. Tous droits réservés.
          </div>
        </div>
      </div>
    </footer>
  );
}
